import { MancalaMoveGenerator } from '../common/MancalaMoveGenerator';
import { KalahRules } from './KalahRules';
export class KalahMoveGenerator extends MancalaMoveGenerator {
    constructor() {
        super(KalahRules.get());
    }
}
